import React, { useState, useEffect } from 'react';
import { useAuth } from "../context/contextAuth";
import { useThemeMode } from "../context/contextTheme";

const CalendlyBooking = () => {
  const { setMeetScheduled } = useAuth();
  const { theme, mode } = useThemeMode();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formSubmittedSuccessfully, setFormSubmittedSuccessfully] = useState(false);
  
  const [formData, setFormData] = useState({
    name: '',
    designation: '',
    companyName: '',
    orgWebsite: '',
    email: '',
    contactNumber: '',
    securityInterests: '',
    previousVapt: ''
  });

  const scriptURL_SAVE = "https://script.google.com/macros/s/AKfycbwVJlIF-gAXOaSxcItjR6kuYXw80IUeD3BPYHMegCJui1z_3Ev4wpH-9EVzsNV4v7_ELw/exec";

  useEffect(() => {
    const link = document.createElement('link');
    link.href = 'https://assets.calendly.com/assets/external/widget.css';
    link.rel = 'stylesheet';
    document.head.appendChild(link);

    const script = document.createElement('script');
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      script.remove();
      link.remove();
    };
  }, []);

  const openCalendly = () => {
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: 'https://calendly.com/savesecurities/save-demo-meeting'
      });
    }
  };

  useEffect(() => {
    const handler = (e) => {
      if (e.data?.event === "calendly.event_scheduled") {
        window.gtag?.("event", "conversion", {
          'send_to': 'AW-10862946136/nAFxCJ7jxKUcENjO7bso',
          'value': 1.0,
          'currency': 'INR',
        });
        if (typeof setMeetScheduled === 'function') {
          setMeetScheduled(true);
        }
      }
    };

    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, [setMeetScheduled]);

  useEffect(() => {
    document.body.style.backgroundImage = "radial-gradient(circle at center, #302158, #100021)";
    document.body.style.minHeight = "100vh";
    document.body.style.margin = "0";
    document.body.style.overflowX = "hidden";
  }, [mode, theme.background]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    try {
      const formSubmissionData = new FormData();
      
      // Exact column mapping matching image_25972d.png headers
      formSubmissionData.append("Name", formData.name);
      formSubmissionData.append("Designation", formData.designation);
      formSubmissionData.append("Company", formData.companyName);
      formSubmissionData.append("Website", formData.orgWebsite);
      formSubmissionData.append("Working Email", formData.email);
      formSubmissionData.append("Contact", formData.contactNumber);
      formSubmissionData.append("Key Areas", formData.securityInterests);
      formSubmissionData.append("VAPT Service Record", formData.previousVapt);

      const response = await fetch(scriptURL_SAVE, {
        method: "POST",
        body: formSubmissionData,
      });

      if (!response.ok) throw new Error("Network error encountered during Apps Script dispatch");
      
      // Form saved successfully -> reveal Calendly access trigger
      setFormSubmittedSuccessfully(true);
    } catch (error) {
      console.error("Submission Failure:", error.message);
      alert("Failed to submit profile metrics. Please confirm network connectivity.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center py-5">
      <div
        className="card border-0 shadow-lg p-4 p-md-5 text-center w-100"
        style={{
          maxWidth: '650px',
          borderRadius: '24px',
          backgroundColor: '#ffffff'
        }}
      >
        <div className="d-inline-flex align-items-center mx-auto mb-4 px-3 py-1 rounded-pill"
          style={{ backgroundColor: '#f0fdf4', border: '1px solid #dcfce7', color: '#166534', fontSize: '12px', fontWeight: '600' }}>
          <span className="rounded-circle me-2" style={{ width: '8px', height: '8px', backgroundColor: '#22c55e' }}></span>
          Live Demo Available
        </div>

        <h1 className="fs-2 fw-bold mb-3 text-dark">
          See <span style={{ color: '#0095ff' }}>SAVE</span> in Action
        </h1>

        {/* Toggle condition shifted to formSubmittedSuccessfully */}
        {!formSubmittedSuccessfully ? (
          <>
            <p className="text-muted small mb-4 px-2">
              Please fill out your corporate details and security requirements below to unlock our 1-on-1 demo scheduling.
            </p>

            <form onSubmit={handleSubmit} className="text-start">
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label small fw-bold text-secondary">Full Name *</label>
                  <input type="text" name="name" required className="form-control bg-light border-0" value={formData.name} onChange={handleInputChange} style={{ borderRadius: '10px' }} />
                </div>

                <div className="col-md-6">
                  <label className="form-label small fw-bold text-secondary">Designation *</label>
                  <input type="text" name="designation" required className="form-control bg-light border-0" value={formData.designation} onChange={handleInputChange} style={{ borderRadius: '10px' }} />
                </div>

                <div className="col-md-6">
                  <label className="form-label small fw-bold text-secondary">Company Name *</label>
                  <input type="text" name="companyName" required className="form-control bg-light border-0" value={formData.companyName} onChange={handleInputChange} style={{ borderRadius: '10px' }} />
                </div>

                <div className="col-md-6">
                  <label className="form-label small fw-bold text-secondary">Organization Website *</label>
                  <input type="url" name="orgWebsite" placeholder="https://" required className="form-control bg-light border-0" value={formData.orgWebsite} onChange={handleInputChange} style={{ borderRadius: '10px' }} />
                </div>

                <div className="col-md-6">
                  <label className="form-label small fw-bold text-secondary">Working Email Address *</label>
                  <input type="email" name="email" required className="form-control bg-light border-0" value={formData.email} onChange={handleInputChange} style={{ borderRadius: '10px' }} />
                </div>

                <div className="col-md-6">
                  <label className="form-label small fw-bold text-secondary">Contact Number (WhatsApp) *</label>
                  <input type="tel" name="contactNumber" required className="form-control bg-light border-0" value={formData.contactNumber} onChange={handleInputChange} style={{ borderRadius: '10px' }} />
                </div>

                <div className="col-12">
                  <label className="form-label small fw-bold text-secondary">Key Areas of Interest / Security Requirements *</label>
                  <textarea name="securityInterests" rows="2" required className="form-control bg-light border-0" value={formData.securityInterests} onChange={handleInputChange} style={{ borderRadius: '10px' }} placeholder="e.g. Cloud Security, Web App Penetration Testing..."></textarea>
                </div>

                <div className="col-12">
                  <label className="form-label small fw-bold text-secondary">Have you performed VAPT services previously? *</label>
                  <select name="previousVapt" required className="form-select bg-light border-0" value={formData.previousVapt} onChange={handleInputChange} style={{ borderRadius: '10px' }}>
                    <option value="">Select option</option>
                    <option value="Yes">Yes, we have done it services previously</option>
                    <option value="No">No, this would be our first time</option>
                  </select>
                </div>
              </div>

              <button 
                type="submit" 
                disabled={isSubmitting}
                className="btn btn-lg w-100 text-white fw-bold mt-4 shadow-sm" 
                style={{ 
                  backgroundColor: '#1a1a5e', 
                  borderRadius: '12px', 
                  border: 'none' 
                }}
              >
                {isSubmitting ? 'Verifying Context...' : 'Verify Requirements & Continue'}
              </button>
            </form>
          </>
        ) : (
          <>
            <p className="text-muted small mb-4 mb-md-5 mx-auto px-2">
              Information validated successfully! You can now book a 1-on-1 walkthrough session with our engineering team below.
            </p>

            <div className="d-grid gap-3 d-sm-flex justify-content-sm-center mb-4">
              <button
                onClick={openCalendly}
                className="btn btn-lg px-5 py-3 text-white fw-bold shadow-sm flex-fill"
                style={{ backgroundColor: '#0095ff', borderRadius: '12px', border: 'none', fontSize: '1rem' }}
              >
                📅 Book Your Demo Meeting
              </button>
            </div>
          </>
        )}

        <div className="border-top pt-3 mt-4">
          <p className="small text-muted mb-0">
            Current Availability:<br className="d-block d-sm-none" />
            <span className="text-dark fw-semibold ms-sm-1">
              Mon — Fri, 10am — 5pm IST
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CalendlyBooking;